export const API_INSTANCE = process.env.REACT_APP_API_INSTANCE
export const WEBSITE_DOMAIN = process.env.REACT_APP_WEBSITE_DOMAIN

//Auth
export const LOGIN = "/auth/login"
export const REGISTER = "/auth/signup"
export const ACCOUNT_TYPE = "/auth/set-account-type"
export const ADD_REFERRAL = "/auth/set-referral-code"
export const GET_REF_ID = "/auth/get-ref"
export const GET_PROFILE = "/profile"
export const FORGET_PASSWORD_REQUEST = "/auth/forgot-password"
export const FORGET_PASSWORD = "/auth/reset-password"

//Update Profile
export const UPDATE_PROFILE = "/profile/personal-info"
export const UPDATE_PROFILE_PICTURE = "/profile/picture"
export const SEND_OTP = "/auth/send-otp"
export const VERIFY_EMAIL = "/auth/verify-email"
export const UPDATE_EMAIL = "/profile/update-email"
export const CHANGE_PASSWORD = "/profile/change-password"
export const USER_INFO = "/profile"
export const CHECK_EMAIL = "/auth/check-email"
export const CHECK_REF_ID = "/auth/check-referral-code"
export const CHECK_USERNAME = "/auth/check-username"
export const FETCH_LATEST_USER_DATA = "/profile/details"
export const VIEW_SECURITY_CODE = "/profile/view-security"
export const ACCEPT_AGREEMENT = "/profile/accept-agreement"

export const GENERATE_GOOGLE_2FA = "/profile/qr-code"
export const VERIFY_GOOGLE2FA = "/profile/toggle-2fa"
export const SET_SECURITY_CODE = "/profile/security-code"

export const NOTIFICATIONS_SETTINGS = "/profile/notification-preference"

export const RECENT_DEVICES = "/profile/recent-device"

//KYC
export const VERIFY_DOCS = "/profile/user-verification/documents"
export const POST_VERIFY = "/profile/user-verification"

//Wallet
export const WALLET_OVERVIEW = "/wallet/overview"
export const WALLET_ASSETS = "/wallet/assets"
export const WALLET_GROWTH = "/wallet/growth"
export const WITHDRAW_HISTORY = "/wallet/withdraw/history"
export const TRANSACTION_HISTORY = "/wallet/history"
export const MIGRATION_HISTORY = "/wallet/migrate/history"
export const ALL_TOKENS = "/wallet/tokens"
export const ALL_NETWORKS = "/wallet/networks"
export const POST_WITHDRAW = "/wallet/withdraw"
export const POST_SWAP = "/wallet/swap"

export const WITHDRAW_ADDRESS = "/wallet/withdraw/addresses"
export const WITHDRAW_PAYMENT_LINK = "/feature/purchase"
export const WALLET_TOKEN_PAIR = "/wallet/swap/ratio"
export const WALLET_MIGRATE = "/wallet/migrate"
export const WALLET_DEPOSIT = "/wallet/topup"
export const WALLET_TOPUP_HISTORY = "/wallet/topup/history"
export const XPL_WALLET_DETAILS = "/wallet/xpl-wallet-details"
export const UNLOCK_XPL_TOKENS = "/wallet/unlock-xpl"
export const CLAIM_XPL_TOKENS = "/wallet/claim-xpl"
export const ADDRESS_VALIDATION = "/wallet/validateAddress"

// XPL to Coins Conversion
export const XPL_COINS_CONVERSION_RATE = "/xpl-coins/conversion-rate"
export const XPL_COINS_CONVERT = "/xpl-coins/convert"
/** GamezBoost coins → XPL (debit coins, credit XPL wallet). */
export const XPL_COINS_CONVERT_TO_XPL = "/xpl-coins/convert-coins-to-xpl"
export const XPL_COINS_BALANCE = "/xpl-coins/balance"
export const COINS_XPL_CONVERSION_RATE = "/xpl-coins/coins-conversion-rate"

//Shop
export const SHOP_PROVIDERS = "/shop/providers"
export const SHOP_METHODS = "/shop/payment-methods"
export const GET_PRODUCTS = "/shop/products"
export const BUY_PRODUCT = "/shop/buy"
export const GET_PURCHASES = "/shop/purchases"
export const GET_ORDER_DATA = "/shop/order"

export const VERIFYING_EMAIL = "/auth/verify-email"
export const STEPPER = "/profile/onboarding-steps"
export const STEPPER_ACCOUNT = "/user/set-ktm"

//Notifications
export const GET_USER_ACTIVITY = "/profile/activity"
export const READ_NOTIFICATIONS = "/profile/activity"
// export const READ_NOTIFICATIONS = "/notifications";
export const DELETE_NOTIFICATIONS = "/notifications/delete/"
export const READ_ALL_NOTIFICATIONS = "/notifications/mark-all-read"
export const NOTIFICATIONS_BADGE = "/notifications/badge"

export const REFERRAL_ACTIVITY_HISTORY = "/user/members-activity"
export const REFERRAL_ANALYTICS = "/user/community/ref-analytics"

export const TOOLS_BASE_SERVER = "https://tools.blpro8.club"
export const CHECK_USER_API: string = TOOLS_BASE_SERVER + "/check-broker-user"
export const ACTIVE_STRATEGY = TOOLS_BASE_SERVER + "/active-strategy"
export const BROKER_ACCOUNT_REGISTRATION: string =
    TOOLS_BASE_SERVER + "/register-broker"

// Utils
export const GET_COUNTRIES = "/utils/countries"
export const EXCHANGE_PLATFORM = "/ex-platform"
export const GET_STORES_URL = "/setting/link"

// Legal Content
export const LEGAL_CONTENT = "/legal-content"

// Feature
export const FEATURE = "/feature"

// Referral
export const REFERRAL_HISTORY = "/referral/history"
export const REFERRAL_USER_REWARDS = "/referral/rewards"
export const REFERRAL_CHART_ANALYTICS = "/referral/users/chart"

// Profile
export const PROFILE_STEPS = "/profile/onboarding-steps"

export const SWAP_HISTORY = "/wallet/swap/history"
export const WALLET_SWAP_PRIORITY = "/wallet/swap/priority"

// Dashboard
export const DASHBOARD_SHOP_PURCHASED = "/shop/purchased"
export const RETRY_USER_VERIFICATION = "/profile/retry-user-verification"

// Setting
export const LINK_LIST = "/setting/link"
export const LINK_WIKI = "/utils/wiki"
export const SHOW_PAGE = "/setting/showpage"

// IMPERSONATE
export const IMPERSONATE_LOGIN = "/auth/impersonate"

// Claimed
export const CLAIM = "/wallet/claim"
export const CLAIM_DATA = "/wallet/claim/overview"
export const CLAIM_HISTORY = "/wallet/claim/history"

//USER STATUS
export const USER_STATUS = "/userDetails/exists"
export const CREATE_USER_DETAILS = "/userDetails/create"
export const UPDATE_USER_DETAILS = "/userDetails/update"

//SUPPORT_CHAT

export const SUPPORT_CHAT_LIST = "/support"

// Gamez Boost
export const GAMEZ_BOOST_AUTH = "/gamez-boost/gamez-boost-auth"
export const GAMEZ_BOOST_BALANCE = "/gamez-boost/balance"
export const GAMEZ_BOOST_REGISTRATION_STATUS = "/gamez-boost/registration-status"